import React from 'react';
import './App.css';
import { RouterProvider } from 'react-router-dom';
import router from './Routers';

function App() {
  return (
    // className='max-w-[1440px] mx-auto min-h-screen'
    <div >
      <RouterProvider router={router}>
      </RouterProvider>
    </div>
  );
}

export default App;
